module.exports = __webpack_public_path__ + "056bf87a6ad955bd4020d66670c773fa.png";